module.exports = __webpack_public_path__ + "img/GAME_QUIZNORI.f88df6fd.png";